import { useEffect, useState } from "react";
import loadIcon from '../images/loader2.webp';
import mailIcon from '../images/mailicon.png';
import whatsappIcon from '../images/msgicon.png';
import axios from "axios";
const Messages=()=>
{
    let [facilities,setFacilities]=useState([]);
    let [clients,setClients]=useState([]);
    let [showfacility,setShowFacility]=useState("none");
    let [progress,setProgress]=useState(false);
    let [formData,setFormData]=useState({to:"",mailmsg:"",whatsappmsg:"",rdvalue:"Active",facilityid:"0"});
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });    
    async function loadFacilities()
    {
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Facilities/GetAll").then(res=>
        {
            if(res.status==200)
            {
                setFacilities(res.data.data);                
            }
        });
        setProgress(false);        
    }       
    async function sendMail(event)
    {
        let to=document.getElementById("to");
        let subject=document.getElementById("subject");
        let mailmsg=document.getElementById("mailmsg");
        if(to.value.length!=10)
        {
            alert("Invalid Email....");
            to.focus();
            return;
        }
        if(subject.value.length<4)
        {
            alert("Invalid Subject....");
            subject.focus();
            return;
        }  
        if(mailmsg.value.length<4)
        {
            alert("Invalid Message....");
            mailmsg.focus();
            return;
        }        
        setProgress(true);
        let mail={to:to.value,subject:subject.value,message:mailmsg.value};
        await apiClient.post("/api/mail/SendSimpleMail",mail).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                alert("Mail Send Successfully");                
            }
        });
        to.value="";
        subject.value="";
        mailmsg.value="";
        setProgress(false);
    }
    async function sendWhatsappMessage(event)
    {
        let mobile=document.getElementById("mobile");
        let name=document.getElementById("name");
        let type=document.getElementById("msgtype");
        if(mobile.value.length!=10)
        {
            alert("Invalid Mobile No....");
            mobile.focus();
            return;
        }
        if(name.value.length<4)
        {
            alert("Invalid Name....");
            name.focus();
            return;
        }        
        setProgress(true);
        await apiClient.post("/api/Whatsapp/SendGeneralMessages/"+mobile.value+"/"+name.value+"/"+type.value).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                alert("Message Send Successfully");                
            }
        });
        mobile.value="";
        name.value="";
        setProgress(false);
        
    }
    async function loadClients()
    {
        setProgress(true);
        await apiClient.get("/api/Subscription/GetAllSubscribers").then((reply)=>
        {
            if(reply.status==200)
            {
                let arr=[...reply.data.data];
                arr.sort((e1,e2)=>
                {
                    if(e1.currentfacility.toUpperCase()==e2.currentfacility.toUpperCase())
                    {
                        return e1.company.toUpperCase()>e2.company.toUpperCase()?1:-1;
                    }
                    else
                    {
                        return e1.currentfacility.toUpperCase()>e2.currentfacility.toUpperCase()?1:-1;
                    }
                });
                setClients([...arr]);
            }
        });
        setProgress(false);
    }
    useEffect(()=>{
        //loadFacilities();
        loadClients();
    },[]);
    return(        
        <div className="row">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-12 p-3">
                <div className="card shadow">
                    <div className="card-header bg-primary text-center text-white h6"><img src={mailIcon} style={{width:'30px'}} /> Send Mails</div>
                    <div className="card-body p-3">
                        <div className="form-group">
                            <label>To</label>
                            <input type="text" list="lstEmails" id="to" className="form-control" />
                            <datalist id="lstEmails">
                                {clients.map((e,i)=>
                                    <option key={i} value={e.email}>{e.currentfacility+"-"+ e.company +"/ "+e.sname}</option>
                                )}
                            </datalist>
                        </div>
                        <div className="form-group">
                            <label>Subject</label>
                            <input type="text" id="subject" className="form-control" />
                        </div>
                        <div className="form-group">
                            <label>Message</label>
                            <textarea className="form-control" id="mailmsg" rows="10"></textarea>
                        </div>
                        <input type="button" onClick={sendMail} value="Send" className="btn btn-primary mt-3" />
                    </div>
                </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-12 p-3">
                <div className="card shadow">
                    <div className="card-header bg-success text-center text-white h6"><img src={whatsappIcon} style={{width:'30px'}} /> Whatsapp Message</div>
                    <div className="card-body p-3"> 
                        <div className="form-group">
                            <label>Whatsapp No</label>
                            <input type="text"  list="lstNumbers" className="form-control" id="mobile"   />
                            <datalist id="lstNumbers">
                                {clients.map((e,i)=>
                                    <option key={i} value={e.mobile}>{e.currentfacility+"-"+ e.company +"/ "+e.sname}</option>
                                )}
                            </datalist>
                        </div>                        
                        <div className="form-group">
                            <label>Name</label>
                            <input type="text" className="form-control" id="name"   />
                        </div>                                               
                        <div className="form-group">
                            <label>Message Type</label>
                            <select id="msgtype" className="form-control">
                                <option value="warning1">First Warning Message</option>
                                <option value="warning2">Second Warning Message</option>
                                <option value="termination">Termination Message</option>
                                <option value="farewell">Farewell Message</option>
                            </select>
                        </div>                        
                        <input type="button" value="Send" onClick={sendWhatsappMessage} className="btn btn-success mt-3" />                        
                    </div>
                </div>
            </div> 
            {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon}  alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}           
        </div>
    );
}
export default Messages;